export const vpMap = {
    sm: 'sm:',
    md: 'md:',
    lg: 'lg:',
    xl: 'xl:',
};

export const classesMap = {
    align: {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right',
        justify: 'text-justify',
    },
    color: {
        dark: 'text-gray-600',
        light: 'text-gray-400',
        white: 'text-white-100',
        brand: 'text-brand',
        urgency: 'text-urgency',
    },
    font: {
        regular: 'font-open-sans-regular',
        italic: 'font-open-sans-italic',
        semibold: 'font-open-sans-semibold',
        'semibold-italic': 'font-open-sans-semibold-italic',
        bold: 'font-open-sans-bold',
        'bold-italic': 'font-open-sans-bold-italic',
    },
    linethrough: 'line-through',
    size: {
        xsmall: 'text-xsmall',
        small: 'text-small',
        medium: 'text-medium',
        large: 'text-large',
        xlarge: 'text-xlarge',
    },
    underline: 'underline visited:underline hover:underline focus:underline active:underline',
};

export const presetsMap = {
    body: {
        constants: {
            color: classesMap.color.dark,
            font: classesMap.font.regular,
        },
        size: classesMap.size.small,
        tags: ['p', 'span'],
    },
    legal: {
        constants: {
            color: classesMap.color.light,
            font: classesMap.font.regular,
        },
        size: classesMap.size.xsmall,
        tags: ['p', 'span'],
    },
    price: {
        constants: {
            color: classesMap.color.dark,
            font: classesMap.font.bold,
        },
        size: classesMap.size.large,
        tags: ['span', 'p'],
    },
    'promo-label': {
        constants: {
            color: classesMap.color.brand,
            font: classesMap.font['semibold-italic'],
        },
        size: classesMap.size.small,
        tags: ['span', 'p'],
    },
    'promo-percent': {
        constants: {
            color: classesMap.color.light,
            font: classesMap.font.italic,
        },
        size: classesMap.size.small,
        tags: ['span', 'p'],
    },
    'promo-was': {
        constants: {
            color: classesMap.color.light,
            font: classesMap.font.italic,
            linethrough: classesMap.linethrough,
        },
        size: classesMap.size.small,
        tags: ['span', 'p'],
    },
    title: {
        constants: {
            color: classesMap.color.dark,
            font: classesMap.font.semibold,
        },
        size: classesMap.size.small,
        tags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    },
    'title-pdp': {
        constants: {
            color: classesMap.color.dark,
            font: classesMap.font.semibold,
        },
        size: `${classesMap.size.medium} ${vpMap.lg}${classesMap.size.large} ${vpMap.xl}${classesMap.size.large}`,
        tags: ['h1'],
    },
    urgency: {
        constants: {
            color: classesMap.color.urgency,
            font: classesMap.font['semibold-italic'],
        },
        size: classesMap.size.medium,
        tags: ['span', 'p'],
    },
};
